export const validatePolicy = (policy) => {
	const warnings = [];
	const errors = [];
	return { errors, warnings, isValid: errors.length === 0 };
};
